module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: true
    },

    methods: {

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers    = this.config.heartbeatRefreshOn || {}
            const key           = message.heartbeatKey

            if(this.$ && this.$.is(':visible')){
                this.model.triggerHeartbeat = {message, heartbeatPrewarmedResourceHashes}
            } else {
                // refresh full form if necessary
                const actualPrimaryKey = this.getFieldValue('primaryKey')
                if(refreshers[key] && !this.config.creationMode && this.config.resourceConnected && !message.isIssuer && (message.data.primaryKey == actualPrimaryKey || message.data.primaryKeys[actualPrimaryKey])){
                    this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
                }
                // check if there are any fields which have to be refreshed on their own.
                // NOTE: if the full form is refreshed the fields will check themselves if it is necessary to reload their resources.
                else {
                    for(const field of this.model.fields || []){
                        const fieldRefreshes = (field.config || {}).heartbeatRefreshOn || {}
                        if(fieldRefreshes[key] && field.fieldCode){
                            const $field = this.$.find(`[data-field-code="${field.fieldCode}"]`)
                            const fieldComponent = getComponent($field, true)
                            if(fieldComponent){
                                fieldComponent.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
                            }
                        }
                    }
                }
            }
        }
    },

    handlers: [
        {
            name: 'onTabDeactivate',
            handle(callerComponent){
                const triggerHeartbeat = this.model.triggerHeartbeat
                if(triggerHeartbeat && this.$ && !this.$.is(':visible')){
                    delete this.model.triggerHeartbeat
                    this.onHeartbeat(triggerHeartbeat.message, triggerHeartbeat.heartbeatPrewarmedResourceHashes)
                }
            }
        },
    ],
}